<template>
  <div id="main_page">
    <image-library-sidebar
      @setImg="setImg"
      :isSidebarActive="ViewSidebar"
      @closeSidebar="toggleImageSidebar"
    />
    <menu-view-sidebar
       @setMenu="setMenu"
       @setPage="setPage"
      :isSidebarActive="ViewMenuSidebar"
      @closeSidebar="toggleMenuSidebar"
    />

    <!-- <vs-button @click="showManue" color="primary"  size="small">Show Menu</vs-button> -->
    <!-- <span>
    <vs-button @click="Save" color="primary"   size="small" class="ml-1"> Save</vs-button>
    <a
      color="primary"
      class="
        vs-component vs-button vs-button-primary vs-button-filled
        small
        text-white
        ml-1
      "
      size="small"
      href="https://dev3.barqsol.com/basic/preview.html"
      target="_blank"
      >Preview</a
    >
    <vs-button
      @click="layer_active = !layer_active"
      color="primary"
      size="small"
      class="ml-1"
      >Layers</vs-button
    >
    <vs-button
      @click="block_active = !block_active"
      color="primary"
      size="small"
      class="ml-1"
      >Blocks</vs-button
    >
    <vs-button @click="page_active = !page_active" color="primary" size="small" class="ml-1"
      >Pages</vs-button
    >
    </span> -->
    <div id="draft-sidebar">
      <vs-sidebar
        id="draft_sidebar"
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="draft_active"
      >
        <div
          class="header-sidebar flex items-center justify-between"
          slot="header"
        >
          <h4 class="ml-5">Drafts &amp; Revisions</h4>
          <feather-icon
            icon="XIcon"
            @click.stop="draft_active = false"
            class="cursor-pointer"
          ></feather-icon>
        </div>
        <div class="px-3">
          <div
            class="vx-card"
            title="Drafts &amp; Revisions"
            v-if="currentDrafts.length > 0"
          >
            <vs-list>
              <vs-list-item
                v-for="(draft, index) in currentDrafts"
                :key="draft"
                :title="'Draft ' + (index + 1)"
                :subtitle="draft"
              >
                <vs-button size="small" @click.native="loadDraft(draft)"
                  >select</vs-button
                >
              </vs-list-item>
            </vs-list>
          </div>
          <div v-else>
            <small>No Drafts &amp; Revisions </small>
          </div>
        </div>
      </vs-sidebar>
    </div>
    <div id="link_sidebar">
      <vs-sidebar
        id="link_sidebar"
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="link_active"
        style="width: 100%"
      >
        <div
          class="header-sidebar flex items-center justify-between"
          slot="header"
        >
          <h4 class="ml-5">Link</h4>
          <feather-icon
            icon="XIcon"
            @click="link_active = false"
            class="cursor-pointer"
          ></feather-icon>
        </div>
        <div class="px-3 py-3">
          <label for="">URL</label>
          <vs-input v-model="link_src.src" class="mb-base mt-1 w-full" />
          <label for="">Title</label>
          <vs-input v-model="link_src.title" class="mt-1 w-full" />
          <small lass="mb-base">Shown when users hover over the link.</small>
          <div class="inline-flex mt-5">
            <vs-switch v-model="link_src.new"></vs-switch>
            <label for="" class="ml-3">Open in a New Window</label>
          </div>
        </div>
        <vs-button
          size="small"
          color="danger"
          style="float: right"
          @click.native="removeLink"
          >Remove Link</vs-button
        >
        <div class="flex flex-wrap items-center p-6" slot="footer">
          <vs-button class="mr-6" @click="submitLink">Add</vs-button>
          <vs-button type="border" color="danger" @click.native="link_active = false"
            >Cancel</vs-button
          >
        </div>
      </vs-sidebar>
    </div>
    <div id="img-sidebar" v-if="img_src">
      <vs-sidebar
        id="img_sidebar"
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="img_active"
        style="width: 100%"
      >
        <div
          class="header-sidebar flex items-center justify-between"
          slot="header"
        >
          <h4 class="ml-5">Image</h4>
          <feather-icon
            icon="XIcon"
            @click.stop="img_active = false"
            class="cursor-pointer"
          ></feather-icon>
        </div>
        <div class="px-3 py-3">
          <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
              <!-- Image Container -->
              <div
                class="
                  img-container
                  w-64
                  mx-auto
                  flex
                  items-center
                  justify-center
                  vs-con-loading__container
                "
                id="div-with-loading"
              >
                <img :src="img_src.src" :alt="img_src.alt" class="responsive" />
              </div>
            </div>
          </div>
          <label for="">URL</label>
          <vx-input-group class="mb-base mt-1">
            <vs-input v-model="img_src.src" />
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button color="primary" @click.native="toggleImageSidebar(true)"
                  >Browse</vs-button
                >
              </div>
            </template>
          </vx-input-group>
          <label for="">Discription</label>
          <vs-textarea v-model="img_src.alt"></vs-textarea>
          <small>Alternative text for users who can't see images.</small>
        </div>
        <div class="flex flex-wrap items-center p-6" slot="footer">
          <vs-button class="mr-6" @click.native="submitImg">Upload</vs-button>
          <vs-button type="border" color="danger" @click.native="img_active = false"
            >Cancel</vs-button
          >
        </div>
      </vs-sidebar>
    </div>
    <div id="layer-sidebar">
      <vs-sidebar
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="layer_active"
      >
        <div
          class="header-sidebar flex items-center justify-between"
          slot="header"
        >
          <h4 class="ml-5">Layers</h4>
          <feather-icon
            icon="XIcon"
            @click.stop="layer_active = false"
            class="cursor-pointer"
          ></feather-icon>
        </div>
        <div class="px-3">
          <div class="editor-row">
            <div class="panel__right">
              <div class="layers-container"></div>
              <div class="styles-container"></div>
            </div>
          </div>
        </div>
      </vs-sidebar>
    </div>
    <div id="block-sidebar">
      <vs-sidebar
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="block_active"
      >
        <div
          class="header-sidebar flex items-center justify-between"
          slot="header"
        >
          <h4 class="ml-5">Blocks</h4>
          <feather-icon
            icon="XIcon"
            @click.stop="block_active = false"
            class="cursor-pointer"
          ></feather-icon>
        </div>
        <div class="px-3">
          <div class="editor-row">
            <div id="blocks"></div>
          </div>
        </div>
      </vs-sidebar>
    </div>
    <div id="page-sidebar">
      <vs-sidebar
        position-right
        parent="body"
        default-index="1"
        color="primary"
        class="sidebarx"
        spacer
        v-model="page_active"
      >
        <div
          class="header-sidebar flex items-center justify-between"
          slot="header"
        >
          <h4 class="ml-5">Pages</h4>
          <feather-icon
            icon="XIcon"
            @click.stop="page_active = false"
            class="cursor-pointer"
          ></feather-icon>
        </div> 
        <div class="px-3">
          <div class="pages-manager">
            <div class="add-page" @click="addPage">+ New Page</div>
            <div class="pages">
              <div
                v-for="page in pages"
                :key="page.id"
                :class="{ page: 1, selected: isSelected(page) }"
                @click="selectPage(page.id)"
              >
                {{ page.get("name") || page.id }}
                <span
                  v-if="!isSelected(page)"
                  @click="removePage(page.id)"
                  class="page-close"
                  >&Cross;</span
                >
              </div>
            </div>
          </div>
        </div>
      </vs-sidebar>
    </div>

    <div class="panel__top">
      <div class="panel__side-actions"></div>
      <div class="panel__basic-actions"></div>
      <div class="panel__devices"></div>
      <div class="panel__switcher"></div>
    </div>
    <div class="editor-canvas" id="editor-canvas">
      <div id="gjs"></div>
    </div>
  </div>
</template>

<script>
import ImageLibrarySidebar from "./ImageLibrarySidebar.vue";
import MenuViewSidebar from "./MenuViewSidebar.vue";
import { VTree, VSelectTree}  from 'vue-tree-halower'
import {
  GET_WEB_TEMP,
  SAVE_WEB_TEMP,
  GET_PAGE_CONTENT,
  SAVE_WEB_DRAFT,
  GET_ALL_DRAFT,
  GET_DRAFT_CONTENT,
  GET_MAIN_MENU
} from "@/graphql";
import grapes from "grapesjs";
import "grapesjs-blocks-basic";
import "grapesjs/dist/css/grapes.min.css";
// import gjsForms from 'grapesjs-plugin-forms'
// import gjsnavbar from 'grapesjs-navbar'
// import styleFilter from 'grapesjs-style-filter';
// import plugin from 'grapesjs-style-bg'
// import flexbox from 'grapesjs-blocks-flexbox'
// import slider from 'grapesjs-lory-slider'
// import tabs from 'grapesjs-tabs'
// import customcode from 'grapesjs-custom-code'
// import tooltip from 'grapesjs-tooltip'
// import gjstouch from 'grapesjs-touch'
// import CKEDITOR from "ckeditor4"
import thePlugin from "grapesjs-plugin-export";
import "grapesjs-plugin-ckeditor";
import {
  main_navbar,
  main_slider,
  main_about,
  main_program,
  main_center,
  main_action,
  main_terminal,
  main_footer,
  base_style,
  main_scripts,
  // main_menu,
} from "../grapesjs/navbar";
export default {
  components: {
    "image-library-sidebar": ImageLibrarySidebar,
     "menu-view-sidebar" :MenuViewSidebar,
      VTree,
    VSelectTree
  },
  data() {
    return {
      activeLoading: false,
      editor: null,
      pages: [],
      layer_active: false,
      block_active: false,
      page_active: false,
      restHtml: null,
      restCss: null,
      nev: main_navbar,
      baseStyle: base_style,
      slider: main_slider,
      about: main_about,
      program: main_program,
      center: main_center,
      action: main_action,
      terminal: main_terminal,
      footer: main_footer,
      srpt: main_scripts,
      ViewSidebar: false,
      ViewMenuSidebar: false,
      img_active: false,
      link_active: false,
      img_src: {
        src: "",
        alt: "",
        title: "",
      },
      link_src: {
        src: "",
        title: "",
        new: false,
      },
      currentDrafts: [],
      draft_active: false,
      s3Url: process.env.VUE_APP_AWS_s3Url,
      linkData: {
        editor: null,
        range: null,
      },
      ckeditor: null,
      mainMenu:['Home','About','Enrollment','Staff','Contact',],
      menuRaw:null,
    //   menuData : [
    //   {'type': 'page', 'title' : 'Home1', 'link': '1'},
    //   {'type': 'page', 'title' : 'Home2', 'link': '2'},
    //   {'type': 'dropdown', 'title' : 'Home3', 'menu' : [
    //     {'type': 'page', 'title' : 'Home', 'link': 'menu1'},
    //     {'type': 'page', 'title' : 'Home1', 'link': 'menu2'},
    //     {'type': 'page', 'title' : 'Home', 'link': '1'},] 
    //   }, 
    //   {'type': 'dropdown', 'title' : 'Home4', 'menu' : [
    //     {'type': 'page', 'title' : 'Home', 'link': 'menu1'},
    //     {'type': 'page', 'title' : 'Home1', 'link': 'menu2'},
    //     {'type': 'page', 'title' : 'Home', 'link': '1'},] 
    //   },
    //    {'type': 'page', 'title' : 'Home5', 'link': '1'},
    //   {'type': 'page', 'title' : 'Home6', 'link': '2'},
    //   {'type': 'dropdown', 'title' : 'Home7', 'menu' : [
    //     {'type': 'page', 'title' : 'Home', 'link': 'menu1'},
    //     {'type': 'page', 'title' : 'Home1', 'link': 'menu2'},
    //     {'type': 'page', 'title' : 'Home', 'link': '1'},] 
    //   },
    //   {'type': 'dropdown', 'title' : 'Home8', 'menu' : [
    //     {'type': 'page', 'title' : 'Home', 'link': 'menu1'},
    //     {'type': 'page', 'title' : 'Home1', 'link': 'menu2'},
    //     {'type': 'page', 'title' : 'Home', 'link': '1'},] 
    //   },
    //  ]  ,
    //  htmlstring:`<div class="navbar container-fluid main-menu navbar-expand-xl"> <div class="container"> <!-- logo --><a href="/" class="nav-brand nav-brand-center"><span><img src="https://dev3.barqsol.com/basic/images/advantage-elc-logo.png" alt="Advantage Logo" title="Advantage Logo" class="d-block mx-auto" /></span></a> <!-- Navbartoggler --><button type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"><span class="navbar-toggle-icon"><i class="fas fa-bars"></i></span></button> <div id="navbarResponsive" class="collapse navbar-collapse"> </div> <!--collapse --> <div class="outer-box clearfix"> </div> </div><!-- /container --> </div>`,
         selectedPage:null,
       initSelected: ['node-1'],
      menuData : [
      {'id':'1','type': 'page', 'title' : 'Home1', 'link': '1', 'expanded': false, 'async': true},
      {'id':'2','type': 'page', 'title' : 'Home2', 'link': '2', 'expanded': false, 'async': true},
      {'id':'3','type': 'dropdown', 'title' : 'Home3','expanded': false, 'async': true, 'menu' : [
        {'type': 'page', 'title' : 'Home', 'link': 'menu1'},
        {'type': 'page', 'title' : 'Home1', 'link': 'menu2','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home', 'link': '1','expanded': false, 'async': true}]
      }, 
      {'id':'4','type': 'dropdown', 'title' : 'Home4','expanded': false, 'async': true, 'menu' : [
        {'type': 'page', 'title' : 'Home', 'link': 'menu1','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home1', 'link': 'menu2','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home', 'link': '1','expanded': false, 'async': true}] 
      },
      {'id':'5','type': 'page', 'title' : 'Home5', 'link': '1','expanded': false, 'async': true},
      {'id':'6','type': 'page', 'title' : 'Home6', 'link': '2','expanded': false, 'async': true},
      {'id':'7','type': 'dropdown', 'title' : 'Home7', 'expanded': false, 'async': true,'menu' : [
        {'type': 'page', 'title' : 'Home', 'link': 'menu1','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home1', 'link': 'menu2','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home', 'link': '1','expanded': false, 'async': true}]
      },
      {'id':'8','type': 'dropdown', 'title' : 'Home8', 'expanded': false, 'async': true,'menu' : [
        {'type': 'page', 'title' : 'Home', 'link': 'menu1','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home1', 'link': 'menu2','expanded': false, 'async': true},
        {'type': 'page', 'title' : 'Home', 'link': '1','expanded': false, 'async': true}] 
      },
     ]  ,
     htmlstring:`<div class="navbar container-fluid main-menu navbar-expand-xl"> <div class="container"> <!-- logo --><a href="/" class="nav-brand nav-brand-center"><span><img src="https://dev3.barqsol.com/basic/images/advantage-elc-logo.png" alt="Advantage Logo" title="Advantage Logo" class="d-block mx-auto" /></span></a> <!-- Navbartoggler --><button type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler"><span class="navbar-toggle-icon"><i class="fas fa-bars"></i></span></button> <div id="navbarResponsive" class="collapse navbar-collapse"> </div> <!--collapse --> <div class="outer-box clearfix"> </div> </div><!-- /container --> </div>`,
     activePrompt:false,
    };
  },
  watch: {
   menuData: {
    handler(val, oldVal) {
       this.createMenu()
    },
    deep: true
  },
  menuRaw(val){
  if(this.editor){
    var editor = this.editor
  // var domComponents = this.editor.DomComponents;
  //   this.editor.select(domComponents.getComponents().models[0]);
  //   const component = this.editor.getSelected();
  //   const coll = component.collection;
  //   const at = coll.indexOf(component);
  //   coll.remove(component);
  //   return coll.add(val, { at });
  //  this.editor.addComponents(val, { at: 0 });
        editor.select(editor.DomComponents.getWrapper().find('.navbar')[0]);
        var parent = editor.getSelected().collection
        console.log(parent)
        var index = editor.getSelected().index()
        var new_index=(index+1)
        console.log(index)
        console.log(new_index)
        console.log(this.menuRaw)
        var new_el =parent.add(this.menuRaw, {at: new_index});
        editor.getSelected().remove();
        editor.select(new_el)
       this.addType()
  }
  },
    link_active(val) {
      // console.log(val)
      if (!val) {
        this.link_src = {
          src: "",
          title: "",
          new: false,
        };
      }
    },
    layoutType(val){
      const _this=this
       if(val==='hidden'){
        this.editor.Panels.removeButton('side-menu','hide_menu');
        this.editor.Panels.addButton('side-menu',{
            id: "show_menu",
             className:'fa fa-arrow-right',
            // label:"<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Show Menu</button>",
            command(editor) {
              _this.shwManue();
            },
            attributes: { title: "Show Menu" },
         });
       }
       else{
           this.editor.Panels.removeButton('side-menu','show_menu');
             this.editor.Panels.addButton('side-menu',{
            id: "hide_menu",
             className:'fa fa-arrow-left',
            // label:"<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Hide Menu</button>",
            command(editor) {
              _this.hideManue();
            },
            attributes: { title: "Hide Menu" },
         });
       }
    }
  },
  computed: {
    pm() {
      if(this.editor){
      return this.editor.Pages;
      }
    },
    layoutType: {
      get() {
        return this.$store.state.mainLayoutType;
      },
      set(val) {
        this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", val);
      },
    },
  },
  mounted() {
    const page = this.$route.params.page;
    if (page) {
      this.loader();
      this.$apollo
        .mutate({
          mutation: GET_PAGE_CONTENT,
          variables: {
            page: page,
          },
        })
        .then((response) => {
          console.log(response)
          this.restHtml = response.data.getPageContent.template;
          this.grapesRender();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.activeLoading = false;
      this.$vs.loading.close();
      this.$router.push("/sites");
      // this.$apollo
      //   .mutate({
      //     mutation: GET_WEB_TEMP,
      //   })
      //   .then((response) => {
      //     this.restHtml = response.data.webTemplate.template;
      //     // const remove = 'data-cfasync="false" src="/cdn-cgi/scripts/5c5dd728/cloudflare-static/email-decode.min.js"';
      //     // this.restHtml=this.restHtml.replace(remove,' ')
      //     // console.log(this.restHtml)

      //     this.grapesRender();
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //   });
      
    }


  },
  methods: {
    grapesRender() {
      const _this = this;
      this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "hidden");
      const LandingPage = {
        html: this.restHtml,
        css: this.restCss,
        components: null,
        style: null,
      };
      CKEDITOR.dtd.$editable.span = 1;
      CKEDITOR.dtd.$editable.a = 1;
      CKEDITOR.dtd.$editable.strong = 1;
      CKEDITOR.dtd.$editable.em = 1;
      CKEDITOR.dtd.$editable.s = 1;
      CKEDITOR.dtd.$editable.u = 1;
      CKEDITOR.dtd.$editable.i = 1;
      CKEDITOR.dtd.$editable.p = 1;
      CKEDITOR.dtd.$editable.sub = 1;
      CKEDITOR.dtd.$editable.sup = 1;
      CKEDITOR.dtd.$editable.h1 = 1;
      CKEDITOR.dtd.$editable.h2 = 1;
      CKEDITOR.dtd.$editable.h3 = 1;
      CKEDITOR.dtd.$editable.h4 = 1;
      CKEDITOR.dtd.$editable.h5 = 1;
      CKEDITOR.dtd.$editable.li = 1;

      CKEDITOR.disableAutoInline = true;
      CKEDITOR.on("instanceCreated", function (ev) {
        var cke = ev.editor;
        cke.on("doubleclick", function (evt) {
          return false;
        });
      });

      // (function () {
      //   console.log("adding");
      //   //Section 1 : Code to execute when the toolbar button is pressed
      //   var a = {
      //       exec: function (editor) {
      //         console.log(editor);
      //         var link = " ";
      //         var title = " ";
      //         var target = " ";
      //         var selectedText = editor.getSelection().getNative();
      //         //  console.log(selectedText)
      //         editor.insertHtml("<a href=\""+link+"\" title=\""+title+"\" target=\""+target+"\">" + selectedText + "</a>");

      //         var bookmarks = editor.getSelection().createBookmarks(true);
      //         // console.log(bookmarks);
      //         //     var range = editor.createRange();
      //         //     range.moveToBookmark(bookmarks[0]);
      //         //     range.select()

      //         //  var link="Sdsdsd"
      //         //           var data = "<a href=\""+link+"\" target=\"_blank\">" + selectedText + "</a>";
      //         //            editor.editable().insertHtmlIntoRange( data, range , "html" )
      //         // var sele = editor.getSelection().selectBookmarks( bookmarks )

      //         // var sel = editor.getSelection(),
      //         // ranges = sel.getRanges(); // CKEDITOR.dom.rangeList instance.

      //         //    var range = ranges[ 0 ];
      //         _this.linkData.range = bookmarks;
      //         _this.linkData.editor = editor;
      //         //   //  console.log(editor.getSelection().document)
      //         //   var attributes = Array();
      //         //   attributes["href"] = "asdasd";
      //         //   attributes["title"] = "asdasdasd";
      //         //   // if(this.link_src.new){
      //         //   //   attributes["title"] ="_blank";
      //         //   // }
      //         //    var style = new CKEDITOR.style( { element : 'a', attributes : attributes } );
      //         //    style.type = CKEDITOR.STYLE_INLINE;
      //         //   //  style.applyToRange( range, editor )
      //         //   style.apply(sele);

      //         //  console.log(editor.getSelection().getNative().innerHTML)
      //         // // var theSelectedText = editor.getSelection().getNative();
      //         // console.log(editor.getSelection().getStartElement().innerHTML)
      //         // // // alert((theSelectedText))
      //         // data.text = editor.getSelection().getSelectedText().toString()
      //         // //  console.log(editor.getSelection())
      //         // var ranges = editor.getSelection().getRanges()
      //         // console.log(ranges)
      //         //  for ( i = 0; i < ranges.length; i++ ) {
      //         //      const	range = ranges[ i ];
      //         //      data.start = range.startOffset
      //         //       data.end = range.endOffset
      //         //  }
      //         //  console.log(data)
      //         //  data.editor = editor
      //         //  var data = editor
      //         //  _this.editor.render();
      //         _this.activeLink();
      //       },
      //     },
      //     //Section 2 : Create the button and add the functionality to it
      //     b = "addLinks";
      //   CKEDITOR.plugins.add(b, {
      //     init: function (editor) {
      //       editor.addCommand(b, a);
      //       editor.ui.addButton("addLinks", {
      //         label: "Add Link",
      //         icon: "link",
      //         command: b,
      //       });
      //       _this.ckeditor = editor;
      //     },
      //   });
      // })();
//       CKEDITOR.plugins.add('addLinks',
// {
//     init: function (editor) {
//         var pluginName = 'addLinks';
//         editor.ui.addButton('addLinks',
//             {
//                 label: 'Add Link',
//                 command: 'OpenLink',
//                 icon: 'link'
//             });
//         var cmd = editor.addCommand('OpenLink', { exec: showLinkDialog });
//     }
// });
// function showLinkDialog(editor) {
//   console.log(editor);
//   var link = "";
//   var title = "";
//   var target = "";
//   var selectedText = editor.getSelection().getNative();
//   //  var bookmarks = editor.getSelection().createBookmarks(true);
//   editor.insertHtml("<a href=\""+link+"\" title=\""+title+"\" target=\""+target+"\">" + selectedText + "</a>");
     
//   // _this.editor.store();
//   // _this.editor.load();
// //   const component = _this.editor.getSelected();
// // //   console.log(component)
// // //   const view = component.getView();
// // //    console.log(view)
// // // // Get the DOM element
// // //    const el =  component.getEl();
// // //     console.log(el)
// //     //  _this.editor.getSelected().set('content', "Zxczxc")
// //       console.log(component.toHTML())
// //       _this.editor.getSelected().components(component.toHTML())
// }

      var plugins = [
        "gjs-plugin-ckeditor",
        (editor) =>
          thePlugin(editor, {
            /* options */
          }),
      ];
      const dltable = (editor) => {
        // console.log("adding components");
        editor.DomComponents.addType("dltable", {
          model: {
            // defaults: {
            // 	tagName: "tr",
            // 	name: "simple-name",
            // 	draggable: "main",
            // 	copyable: false,
            // 	removable: false,
            // 	components: {
            // 		tagName: "td",
            // 		name: "unrecognized-td",
            // 		hoverable: false,
            // 		draggable: false,
            // 		selectable: false,
            // 		removable: false,
            // 		highlightable: false
            // 	}
            // }
          },
        });
      };

      plugins.push(dltable);

      const editor = (this.editor = grapes.init({
        container: "#gjs",
        appendOnClick: 1,
        allowScripts: 1,
        jsInHtml: true,
        fromElement: false,
        components: LandingPage.components || LandingPage.html,
        style: LandingPage.style || LandingPage.css,
        storageManager: {
          autoload: false,
          autosave: false,
        },
          // canvas: {
          // styles: [
          //   'https://dev3.barqsol.com/basic/css/plugin.css',
          //   'https://dev3.barqsol.com/basic/js/layerslider/css/layerslider.css',
          //   'https://dev3.barqsol.com/basic/plugins/revolution/css/navigation.css',
          //   'https://dev3.barqsol.com/basic/css/style.css',
          //   'https://dev3.barqsol.com/basic/css/responsive.css',
          //   'https://dev3.barqsol.com/basic/fonts/flaticons/flaticon.css',
          //   'https://dev3.barqsol.com/basic/js/layerslider/skins/fullwidth/skin.css'
          // ],
        //   scripts:[
        //   "https://dev3.barqsol.com/basic/js/jquery.js",
        //  "https://dev3.barqsol.com/basic/js/popper.min.js",
        //  "https://dev3.barqsol.com/basic/js/bootstrap.min.js",
        //  "https://dev3.barqsol.com/basic/js/jquery-ui.js",
        //  "https://dev3.barqsol.com/basic/js/jquery.fancybox.js",
        //  "https://dev3.barqsol.com/basic/js/owl.js",
        //  "https://dev3.barqsol.com/basic/js/jquery.countdown.js",
        //  "https://dev3.barqsol.com/basic/js/wow.js",
        //  "https://dev3.barqsol.com/basic/js/appear.js",
        //  "https://dev3.barqsol.com/basic/js/parallax.min.js",
        //  "https://dev3.barqsol.com/basic/js/pretty.js",
        //  "https://dev3.barqsol.com/basic/js/cookie.js",
        //  "https://dev3.barqsol.com/basic/js/script.js",
        //   "https://maps.googleapis.com/maps/api/js?key=AIzaSyDcaOOcFcQ0hoTqANKZYz-0ii-J0aUoHjk",
        //   "https://dev3.barqsol.com/basic/js/jquery.isotope.js",
        //   "https://dev3.barqsol.com/basic/js/map-script.js",
        //   "https://dev3.barqsol.com/basic/js/isotopeload.js",
        //   "https://dev3.barqsol.com/basic/js/contact.js",
        //   "https://dev3.barqsol.com/basic/js/layerslider/js/greensock.js",
        //   "https://dev3.barqsol.com/basic/js/layerslider/js/layerslider.transitions.js",
        //   "https://dev3.barqsol.com/basic/js/layerslider/js/layerslider.kreaturamedia.jquery.js",
        //   "https://dev3.barqsol.com/basic/js/main-slider-script.js" ,
        //   "https://dev3.barqsol.com/basic/js/respond.js"
        //   ]

          // },
        plugins: plugins,
        // storageManager: {
        //   id: "gjs-", // Prefix identifier that will be used on parameters
        //   type: "local", // Type of the storage
        //   autosave: false, // Store data automatically
        //   autoload: false, // Autoload stored data on init
        //   stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
        //   storeHtml: 1,
        //   storeCss: 1, //Enable/Disable saving CSS template

        //   // type: 'remote',
        //   // params:{
        //   //      'Access-Control-Allow-Origin':'https://localhost:8080',
        //   //           },
        //   // // urlStore: 'https://dev3.barqsol.com/tester',
        //   // // urlLoad: 'https://dev3.barqsol.com/tester',
        //   // contentTypeJson: true,
        //   // params: { _some_token: '....' },
        //   // headers: { Authorization: 'Basic ...' },
        // },
        pluginsOpts: {
          "gjs-plugin-ckeditor": {
            position: "center",
            options: {
              language: "en",
              startupFocus: true,
              extraAllowedContent: "*(*);*{*}", // Allows any class and any inline style
              allowedContent: true, // Disable auto-formatting, class removing, etc.
              enterMode: CKEDITOR.ENTER_BR,
              // uiColor : '#CCEAEE', // Inline editor color
              extraPlugins:
                "sharedspace,justify,colorbutton,panelbutton,font,",
              toolbar: [
                // { name: "styles", items: ["Format", "Font", "FontSize"] },
                { name: "styles", items: ["Format"] },
                ["Bold", "Italic", "Underline", "Strike"],
                // { name: "links", items: ["addLinks",] },
                 { name: "links", items: ["Link",'Unlink'] },
                {
                  name: "paragraph",
                  items: [
                    "NumberedList",
                    "BulletedList",
                    "JustifyLeft",
                    "JustifyCenter",
                    "JustifyRight",
                    "JustifyBlock",
                  ],
                },
                { name: "colors", items: ["TextColor", "BGColor"] },
              ],
            },
          },
        },
        // The `components` accepts HTML string or a JSON of components
        // Here, at first, we check and use components if are already defined, otherwise
        // the HTML string gonna be used
        components: LandingPage.components || LandingPage.html,
        // // // We might want to make the same check for styles
        style: LandingPage.style || LandingPage.css,
        // Size of the editor
        //  storageManager: false,
        // Disable the storage manager for the moment
        pageManager: {
          appendTo: ".page-container",
          pages: [
            {
              id: "page-1",
              name: "Page 1",
              // component: this.restHtml,
              component: LandingPage.components || LandingPage.html,
               style: LandingPage.style || LandingPage.css,
            },
            {
              id: "page-2",
              name: "Page 2",
              component: '<div id="comp3">Page 2</div>',
              styles: ``,
            },
            {
              id: "page-3",
              name: "Page 3",
              component: '<div id="comp3">Page 3</div>',
              styles: `#comp3 { color: blue }`,
            },
          ],
        },

        // Avoid any default panel
        layerManager: {
          appendTo: ".layers-container",
        },
        deviceManager: {
          devices: [
            {
              name: "Desktop",
              width: "", // default size
            },
            {
              name: "Tablet",
              width: "640px", // this value will be used on canvas width
              widthMedia: "960px", // this value will be used in CSS @media
            },
            {
              name: "Mobile",
              width: "320px", // this value will be used on canvas width
              widthMedia: "480px", // this value will be used in CSS @media
            },
          ],
        },
        selectorManager: {
          appendTo: ".styles-container",
        },
        styleManager: {
          appendTo: ".styles-container",
          sectors: [
            {
              name: "Dimension",
              open: false,
              // Use built-in properties
              buildProps: ["width", "min-height", "padding"],
              // Use `properties` to define/override single property
              properties: [
                {
                  // Type of the input,
                  // options: integer | radio | select | color | slider | file | composite | stack
                  type: "integer",
                  name: "The width", // Label for the property
                  property: "width", // CSS property (if buildProps contains it will be extended)
                  units: ["px", "%"], // Units, available only for 'integer' types
                  defaults: "auto", // Default value
                  min: 0, // Min value, available only for 'integer' types
                },
              ],
            },
            {
              name: "Extra",
              open: false,
              buildProps: ["background-color", "box-shadow", "custom-prop"],
              properties: [
                {
                  id: "custom-prop",
                  name: "Custom Label",
                  property: "font-size",
                  type: "select",
                  defaults: "32px",
                  // List of options, available only for 'select' and 'radio'  types
                  options: [
                    { value: "12px", name: "Tiny" },
                    { value: "18px", name: "Medium" },
                    { value: "32px", name: "Big" },
                  ],
                },
              ],
            },
          ],
        },
        // We define a default panel as a sidebar to contain layers
        panels: {
          defaults: [
            {
              id: "layers",
              el: ".panel__right",
              // Make the panel resizable
              resizable: {
                maxDim: 350,
                minDim: 200,
                tc: 0, // Top handler
                cl: 1, // Left handler
                cr: 0, // Right handler
                bc: 0, // Bottom handler
                // Being a flex child we need to change `flex-basis` property
                // instead of the `width` (default)
                keyWidth: "flex-basis",
              },
            },
          ],
        },
        blockManager: {
          appendTo: "#blocks",
          appendOnClick:1,
          blocks: []
          // blocks: [
          //   {
          //     id: 'section', // id is mandatory
          //     label: '<b>Section</b>', // You can use HTML/SVG inside labels
          //     attributes: { class:'gjs-block-section' },
          //     content: `<section>
          //       <h1>This is a simple title</h1>
          //       <div>This is just a Lorem text: Lorem ipsum dolor sit amet</div>
          //     </section>`,
          //   }, {
          //     id: 'text',
          //     label: 'Text',
          //     content: '<div data-gjs-type="text">Insert your text here</div>',
          //   }, {
          //     id: 'image',
          //     label: 'Image',
          //     // Select the component once it's dropped
          //     select: true,
          //     // You can pass components as a JSON instead of a simple HTML string,
          //     // in this case we also use a defined component type `image`
          //     content: { type: 'image' },
          //     // This triggers `active` event on dropped components and the `image`
          //     // reacts by opening the AssetManager
          //     activate: true,
          //   }
          // ]
        },
      }));
      var blockManager = editor.BlockManager;
//       blockManager.add('h1-block', {
//       label: 'Heading',
//       disable: 1,
//       content: '<h1>Put your title here</h1>',
//       category: 'Basic',
//       attributes: {
//         title: 'Insert h1 block'
//       }
// });
      // 'my-first-block' is the ID of the block
      blockManager.add("main_navbar", {
        label: `<div>
        <img src="https://dev3.barqsol.com/snipt/navbar.PNG" width="100%"/>
        <div class="my-label-block" style="margin-top:10px">Navbar</div>
        </div>`,
        content: this.baseStyle + this.nev,
        content: '<h1>Put your title here</h1>',
        category: { label: "Navigations", open: false },
        attributes: {},

        // If true, triggers an 'active' event on dropped component
      });
      //   blockManager.add("main_slider", {
      //     label: `<div>

      //   <img src="https://dev3.barqsol.com/snipt/navbar1.PNG" width="100%"/>
      //   <div class="my-label-block" style="margin-top:10px">Simple Navbar</div>
      // </div>`,
      //     content: this.slider+this.srpt+this.baseStyle,
      //     category: "Sliders",
      //   });
      blockManager.add("main_about", {
        label: `<div>
   
      <img src="https://dev3.barqsol.com/snipt/center.PNG" width="100%"/>
      <div class="my-label-block" style="margin-top:10px">About</div>
    </div>`,

        content: this.baseStyle + this.about,
        category: { label: "About", open: false },
      });
      blockManager.add("main_program", {
        label: `<div>
   
      <img src="https://dev3.barqsol.com/snipt/program.PNG" width="100%"/>
      <div class="my-label-block" style="margin-top:10px">Program</div>
    </div>`,
        content: this.baseStyle + this.program,
        category: { label: "Program", open: false },
      });
      blockManager.add("main_center", {
        label: `<div>
   
      <img src="https://dev3.barqsol.com/snipt/center2.PNG" width="100%"/>
      <div class="my-label-block" style="margin-top:10px">Center</div>
    </div>`,
        content: this.baseStyle + this.center,
        category: { label: "Center", open: false },
      });
      blockManager.add("main_action", {
        label: `<div>
   
      <img src="https://dev3.barqsol.com/snipt/action.PNG" width="100%"/>
      <div class="my-label-block" style="margin-top:10px">Center</div>
    </div>`,
        content: this.baseStyle + this.action,
        category: { label: "Center", open: false },
      });
      blockManager.add("main_terminal", {
        label: `<div>
   
      <img src="https://dev3.barqsol.com/snipt/test.PNG" width="100%"/>
      <div class="my-label-block" style="margin-top:10px">Testimonial</div>
    </div>`,
        content: this.baseStyle + this.terminal,
        category: { label: "Testimonial", open: false },
      });
      blockManager.add("main_footer", {
        label: `<div>
   
      <img src="https://dev3.barqsol.com/snipt/footer.PNG" width="100%"/>
      <div class="my-label-block" style="margin-top:10px">Footer</div>
    </div>`,
        content: this.baseStyle + this.footer,
        category: { label: "Footer", open: false },
      });
      editor.Panels.addPanel({
        id: "panel-top",
        el: ".panel__top",
      });
      editor.Panels.addPanel({
        id: "side-menu",
        el: ".panel__side-actions",
        buttons:[
            {
            id: "hide_menu",
            // label:"<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Hide Menu</button>",
            // label: "<small>Hide Menu</small>",
            className:'fa fa-arrow-left',
            command(editor) {
              _this.hideManue();
            },
            attributes: { title: "Hide Menu" },
          },
          // {
          //   id: "show_menu",
          //   label:
          //     "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Show Menu</button>",
          //   command(editor) {
          //     _this.shwManue();
          //   },
          //   attributes: { title: "Show Menu" },
          // },
          
          
        ],
      });
      editor.Panels.addPanel({
        id: "basic-actions",
        el: ".panel__basic-actions",
        buttons: [
          // {
          //   id: "visibility",
          //   active: true, // active by default
          //   className: "btn-toggle-borders",
          //   label: "<u>B</u>",
          //   command: "sw-visibility", // Built-in command
          // },
          // {
          //   id: "preview",
          //   className: "fa fa-eye",
          //   // label: "<small>Preview</small>",
          //   command: "preview", // Built-in command
          // },
          // {
          //   id: "export",
          //   className: "fa fa-download",
          //   // label: 'Exp',
          //   command: "export-template",
          //   context: "export-template", // For grouping context of buttons from the same panel
          //   attributes: { title: "Download" },
          // },
          // {
          //   id: "show-json",
          //   className: "fa fa-code",
          //   // label: 'JSON',
          //   context: "show-json",
          //   attributes: { title: "Show JSON" },
          //   command(editor) {
          //     editor.Modal.setTitle("Components JSON")
          //       .setContent(
          //         `<textarea style="width:100%; height: 250px;">
          //   ${JSON.stringify(editor.getComponents())}
          // </textarea>`
          //       )
          //       .open();
          //   },
          // },
          {
            id: "show_blocks",
            // label: "<small>Add Blocks</small>",
            label:
              "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Add Blocks</button>",
            command(editor) {
              _this.block_active = true;
            },
            attributes: { title: "Show Blocks" },
          },
          {
            id: "save-db",
            // className: "fa fa-floppy-o",
            // command: "save-db",
            label:
              "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Publish</button>",
            command(editor, sender) {
              sender && sender.set("active"); // turn off the button
              //  editor.store();
              _this.Save();
            },
            attributes: { title: "Save as Draft" },
          },
          {
            id: "save-df",
            // className: "fa fa-floppy-o",
            // command: "save-db",
            label:
              "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Save Draft</button>",
            command(editor, sender) {
              //  editor.store();
              _this.SaveDraft();
            },
            attributes: { title: "Save Draft" },
          },
          {
            id: "view-df",
            // className: "fa fa-floppy-o",
            // command: "save-db",
            label:
              "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Drafts & Revisions</button>",
            command(editor, sender) {
              _this.draft_active = true;
            },
            attributes: { title: "View Drafts" },
          },
          // {
          //   id: "show_layers",
          //   label: "<small>Layers</small>",
          //   command(editor) { _this.layer_active=true},
          //   attributes: { title: "Show Layers" },
          // },
          {
            id: "show_pages",
            label: "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Pages</button>",
            command(editor) { _this.page_active=true},
            attributes: { title: "Show Pages" },
          },
          {
            id: "show_preview",
            label: "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>View Page</button>",
            // label: "<small>Preview</small>",
            // className: "fa fa-rocket",
            command(editor) {
              _this.ShowPreview(); },
            attributes: { title: "View Page" },
          },
           {
            id: "main_menu",
            label: "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Menu</button>",
            command(editor) { _this.toggleMenuSidebar(true)},
            attributes: { title: "Show Menu" },
          },
          //           {
          //   id: "hide_menu",
          //   // label:"<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Hide Menu</button>",
          //   // label: "<small>Hide Menu</small>",
          //   className:'fa fa-arrow-left',
          //   command(editor) {
          //     _this.hideManue();
          //   },
          //   attributes: { title: "Hide Menu" },
          // },
          // // {
          // //   id: "show_menu",
          // //   label:
          // //     "<button type='button' class='vs-button-linex vs-button-text vs-button--text vs-component vs-button vs-button-primary vs-button-filled small'>Show Menu</button>",
          // //   command(editor) {
          // //     _this.shwManue();
          // //   },
          // //   attributes: { title: "Show Menu" },
          // // },
          
          
        ],
      });
      editor.Panels.addPanel(
        
        {
          id: "panel-devices",
          el: ".panel__devices",
          buttons: [
            {
              id: "device-desktop",
              // label: 'D',
              className: "fa fa-desktop",
              command: "set-device-desktop",
              active: true,
              togglable: false,
            },
            {
              id: "device-tablet",
              // label: 'T',
              className: "fa fa-tablet",
              command: "set-device-tablet",
              togglable: false,
            },
            {
              id: "device-mobile",
              // label: 'M',
              className: "fa fa-mobile",
              command: "set-device-mobile",
              togglable: false,
            },
          ],
        },
        {
          id: "panel-switcher",
          el: ".panel__switcher",
          buttons: [
            // ...
            {
              id: "show-traits",
              active: true,
              label: "Traits",
              command: "show-traits",
              togglable: false,
            },
          ],
        },
        
      );
       

      // Commands
      editor.Commands.add("show-layers", {
        getRowEl(editor) {
          return editor.getContainer().closest(".editor-row");
        },
        getLayersEl(row) {
          return row.querySelector(".layers-container");
        },

        run(editor, sender) {
          const lmEl = this.getLayersEl(this.getRowEl(editor));
          lmEl.style.display = "";
        },
        stop(editor, sender) {
          const lmEl = this.getLayersEl(this.getRowEl(editor));
          lmEl.style.display = "none";
        },
      });
      editor.Commands.add("show-styles", {
        getRowEl(editor) {
          return editor.getContainer().closest(".editor-row");
        },
        getStyleEl(row) {
          return row.querySelector(".styles-container");
        },

        run(editor, sender) {
          const smEl = this.getStyleEl(this.getRowEl(editor));
          smEl.style.display = "";
        },
        stop(editor, sender) {
          const smEl = this.getStyleEl(this.getRowEl(editor));
          smEl.style.display = "none";
        },
      });
      editor.Commands.add("set-device-desktop", {
        run: (editor) => editor.setDevice("Desktop"),
      });
      editor.Commands.add("set-device-mobile", {
        run: (editor) => editor.setDevice("Mobile"),
      });
      editor.Commands.add("set-device-tablet", {
        run: (editor) => editor.setDevice("Tablet"),
      });
      // Add the command
      editor.Commands.add("save-db", {
        run: function (editor, sender) {
          sender && sender.set("active"); // turn off the button
          editor.store();
        },
      });
      editor.Commands.add("open-assets", () => console.log(" "));
      editor.Commands.add("add-component", () =>  _this.block_active = true);
     
      editor.Commands.add("move-up", {
        run: function (editor) {
          const selected = editor.getSelected().getEl();

          console.log(selected);

          const selectedPrevious = selected.previousElementSibling;

          console.log(selectedPrevious);

          const parent = selected.parentNode;

          console.log(parent);

          parent.insertBefore(selected, selectedPrevious);

          //  const sel = editor.getSelected().getEl().previousElementSibling;
          //  var parent = sel.parentNode;
          //  var position = Array.prototype.indexOf.call(parent.children, sel);
          //  console.log(position)

          // var parent_selected = selected.collection;
          // const position = (selected.index() -2)
          // console.log(position)
          // // console.log(editor.getSelected().closest(options?.parentSelector || '#wrapper > div'))
          // selected.remove({ temporary: true }); // temporary option will avoid removing component related styles
          // editor.getWrapper().append(selected, {  at: position});
        },
      });

      // editor.addComponents(this.menuRaw, { at: 0 });
      // // editor.getComponents().add('<div>Text ddf dfsf</div>', {at: 1});
      editor.Commands.add("move-down", {
        run: function (editor) {
          const selected = editor.getSelected().getEl();

          console.log(selected);

          const selectedNext = selected.nextElementSibling;
          console.log(selectedNext);
          // const new_selectedNext = selectedNext.nextElementSibling

          // console.log(new_selectedNext);
          if (selectedNext) {
            insertAfter(selectedNext, selected);
          }
          function insertAfter(referenceNode, newNode) {
            referenceNode.parentNode.insertBefore(
              newNode,
              referenceNode.nextSibling
            );
          }
          // const parent = selected.parentNode;

          // console.log(parent);

          // parent.insertBefore(selected, new_selectedNext);

          //  var selected = editor.getSelected();
          //  const sel = editor.getSelected().getEl().nextElementSibling;
          //  var parent = sel.parentNode;
          //  var position = Array.prototype.indexOf.call(parent.children, sel);
          //  console.log(position)
          // const coll = sel.collection;
          // const index = coll.indexOf(sel);
          // const nextModel = coll.at(index + 1);
          // console.log(nextModel.index())
          // const position = nextModel.index()
          // // const selected = editor.getSelected();
          // // console.log(selected.nextSibling)
          // // console.log(selected.index())

          // // // var parent_selected = selected.collection;
          // // const position = (selected.index() - 1)
          // //  console.log(position)
          // // // console.log(editor.getSelected().closest(options?.parentSelector || '#wrapper > div'))
          // selected.remove({ temporary: true }); // temporary option will avoid removing component related styles
          // editor.getWrapper().append(selected, {  at: position});
          // editor.select(selected)
        },
      });
      // editor.on('load', function()
      // {
      //     const updateAll = model => {
      //         model.set({toolbar:[],editable:true,hoverable:false,removable:false,copyable: false,draggable:false,dropable:false,moveable:false});
      //         model.get('components').each(model => updateAll(model));
      //     }
      //     updateAll(editor.DomComponents.getWrapper());

      // });
      // const script = function() {
      //   alert('Hi');
      //   // `this` is bound to the component element
      //   console.log('the element', this);
      // };

      // // Define a new custom component
      //  const defaultType = editor.Components.getType('text');
      //  console.log(defaultType)
      // editor.Components.addType('dltable', {
      //    view: defaultType.viewv
      //   // model: {
      //   //   defaults: {
      //   //     script,
      //   //     // Add some style, just to make the component visible
      //   //     style: {
      //   //       width: '100px',
      //   //       height: '100px',
      //   //       background: 'red',
      //   //     },
      //   //     content:this.baseStyle+this.slider+this.srpt
      //   //   }
      //   // }
      // });

      // Create a block for the component, so we can drop it easily
      // editor.Blocks.add('test-block', {
      //   label: 'Test block',
      //   attributes: { class: 'fa fa-text' },
      //   content: { type: 'comp-with-js' },
      // });
      // const dc = editor.DomComponents;
      //   editor.on('load', () => editor.select(dc.getComponents().at(0)));
      //   editor.on("load", function () {
      //     console.log(_this.menuRaw)
              // editor.addComponents(this.menuRaw, { at: 0 });
      //     editor.select(editor.getComponents().models[0])
      //     editor.getComponents().models[0].append(_this.menuRaw)
      // // // editor.getComponents().add('<div>Text ddf dfsf</div>', {at: 1});
      //   })
        if(editor.DomComponents.getWrapper().find('.navbar').length > 0){
        editor.select(editor.DomComponents.getWrapper().find('.navbar')[0]);
        var parent = editor.getSelected().collection
        console.log(parent)
        var index = editor.getSelected().index()
        var new_index=(index+1)
        console.log(index)
        console.log(new_index)
        console.log(this.menuRaw)
        var new_el =parent.add(this.menuRaw, {at: new_index});
        editor.getSelected().remove();
        editor.select(new_el)
        }
      editor.on("load", function () {

        const updateAll = (model) => {
          model.onAll((innerComponent) => {
            // console.log(innerComponent.get('type'))
            if (innerComponent.is("dltable")) {
              //  console.log(innerComponent.getEl())
              innerComponent.set({
                toolbar: [
                  {
                    attributes: { class: "fa fa-trash" },
                    command: "tlb-delete",
                  },
                  {
                    attributes: { class: "fa fa-arrow-up" },
                    command: "move-up",
                  },
                  {
                    attributes: { class: "fa fa-arrow-down" },
                    command: "move-down",
                  },
                    {
                    attributes: { class: "fa fa-th-large" },
                    command: "add-component",
                  },
                ],
                selectable: true,
                editable: true,
                hoverable: false,
                removable: true,
                copyable: false,
                draggable: false,
                dropable: false,
                moveable: false,
                badgable: false,
              });
            } 
            else {
              innerComponent.set({
                toolbar: [],
                selectable: true,
                editable: true,
                hoverable: false,
                removable: false,
                copyable: false,
                draggable: false,
                dropable: false,
                moveable: false,
              });
              //  innerComponent.set({toolbar:[{ attributes: {class: 'fa fa-trash'}, command: 'tlb-delete'} ,{ attributes: {class: 'fa fa-arrow-up'}, command: 'move-up' }, { attributes: {class: 'fa fa-arrow-down'}, command: 'move-down' },],selectable: true,editable:true,hoverable:false,removable:true,copyable: false,draggable:false,dropable:false,moveable:true,badgable:false});
            }
          });
          // model.set({toolbar:[],selectable: false,editable:true,hoverable:false,removable:false,copyable: false,draggable:false,dropable:false,moveable:false});
          model.get("components").each((model) => updateAll(model));
        };
        updateAll(editor.DomComponents.getWrapper());
      });

      // editor.on('component:styleUpdate', function(){

      // const style = model.getStyle()
      //         delete style['background-image']
      //         delete style['background-repeat']
      //         delete style['background-position']
      //         delete style['background-attachment']
      //         delete style['background-size']
      //         component.setStyle(style)

      // });

      // const domc = editor.DomComponents;
      //   const defaultType = domc.getType('text');
      //   console.log( defaultType);
      //   const defaultModel = defaultType.model;
      //   const defaultView = defaultType.view;
      //   domc.addType('text', {
      //   model: defaultModel,
      //   view: defaultView.extend({
      //      selectable: true,
      //       attributes: {
      //       contenteditable: true,
      //     }
      //   }),
      // });
      editor.on("component:selected", () => {
        _this.img_active = false;
        const selected = editor.getSelected();
        // console.log(editor.getSelected())
        //  console.log(selected.get('type'))
        if (selected && selected.is("image")) {
          _this.img_src.src = selected.get("src");
          _this.img_src.alt = selected.get("attributes").alt;
          _this.img_src.title = selected.get("attributes").title;
          _this.img_active = true;
        }
        // if (selected && selected.is("link")) {
        //   _this.link_src.src = selected.get("attributes").href;
        //   _this.link_src.title = selected.get("attributes").title;
        //   console.log(selected.get("attributes").target)
        //    if(selected.get("attributes").target){
        //       if(selected.get("attributes").target==="_blank"){
        //         _this.link_src.new = true;
        //        }
        //    }
        //   _this.link_active = true;
        // }
      });
       editor.on('block:active', block => {
         console.log("ASdasdas")
          console.log(block)
      //   console.log(block.attributes.content)
      //   var parent = editor.getSelected().collection
      //   console.log(parent)
      //   var index = editor.getSelected().index()
      //   var new_index=(index+1)
      //   console.log(index)
      //   console.log(new_index)
      //   // var new_el=parent.append(block.attributes.content,{at: new_index})
      //   var new_el =parent.add(block.attributes.content, {at: new_index});
        // editor.select(new_el)
       }),
      editor.on('block:add', block => {
        alert("Asdasd")
      // //  console.log(block)
      // //   console.log(block.attributes.content)
      //   var parent = editor.getSelected().collection
      //   // console.log(parent)
      //   var index = editor.getSelected().index()
      //   var new_index=(index+1)
      //   // console.log(index)
      //   // console.log(new_index)
      //   // var new_el=parent.append(block.attributes.content,{at: new_index})
      //   var new_el =parent.add(block.attributes.content, {at: new_index});
      //   editor.select(new_el)
        // editor.addComponents({components: block.attributes.content,});
        });
     editor.on('block:drag:start', block => {
      //  console.log(block)
      //   console.log(block.attributes.content)
        var parent = editor.getSelected().collection
        // console.log(parent)
        var index = editor.getSelected().index()
        var new_index=(index+1)
        // console.log(index)
        // console.log(new_index)
        // var new_el=parent.append(block.attributes.content,{at: new_index})
        var new_el =parent.add(block.attributes.content, {at: new_index});
        editor.select(new_el)
        // editor.addComponents({components: block.attributes.content,});
        });
//       //  let doc = new DOMParser().parseFromString(block.attributes.content, 'text/html');
//       //   let div = doc.body.firstChild;
//       //    console.log(div)
//       //    const selected = editor.getSelected().getEl();
//       //     console.log(selected);
//       //     const parent = selected.parentNode;
//       //     const selectedNext = selected.nextElementSibling;
//       //     console.log(selectedNext);
//       //     parent.insertBefore(div, selectedNext);


//       // if (target && target.getName() === 'Link') {
//       //   editor.runCommand('open-assets', {
// 			// target, // Not sure if the 'Link' is the correct target as it doesn't have `src`
// 			// onSelect: () => editor.Modal.close(),
//       //   });
//       // }
//     })
      // editor.on('change:selectedComponent', model => {
      //   console.log('New content', model.get('content'));
      //   // do your stuff...
      // })
      // editor.on('component:selected', component => {
      // editor.on('component:update:content', model => {
      //   console.log('New content', model.get('content'));
      //    var val = model.get('content');
      //   console.log(val)
      //    if(val.length === 0){
      //       model.set('content', '&nbsp');
      //    }
      //    else{
      //      model.set('content',val)
      //    }
      // })
      // });
      // editor.on('component:update:content', (componentView) => { 
      //   const model = componentView.model; 
      //   const innerHTML = componentView.$el[0].innerHTML; 
      //   const contentModel = model.get('content'); 
      //   if (contentModel !== innerHTML) { 
      //   model.set('content', innerHTML); 
      //   const html = editor.getHtml(); const css = editor.getCss(); 
      //   editor.DomComponents.getWrapper().set('content', ''); 
      //   editor.setComponents(html); editor.setStyle(css); 
      //   } 
      //   });
      // editor.on('component:update:content', model => {
      //   // editor.DomComponents.getWrapper().render()
      //   // console.log( model.get('content'))
      //     const html = editor.getHtml(); 
      //     // const css = editor.getCss(); 
      //   editor.DomComponents.getWrapper().set('content', ''); 
      //   editor.setComponents(html);
      //   // editor.setStyle(css)
      // })
      //       var originalText = domc.getType('text')
      // domc.addType('text', {
      //    model: originalText.model.extend({
      //       defaults: Object.assign({}, originalText.model.prototype.defaults, {
      //          tagName: 'div',
      //          name: 'MyText',
      //          draggable: '*',
      //          droppable: false,
      //          attributes: { 'data-mytext': 'MyText' },
      //       }),
      //    }, {
      //       isComponent: function (el) {
      //          if (el.tagName === 'DIV' && el.getAttribute('data-mytext') === 'MyText') {
      //             const contentTexts = []
      //             Array.from(el.childNodes).forEach((node) => {
      //                if (node.textContent == '') {
      //                   contentTexts.push(node.textContent)
      //                }
      //             })
      //             const content = contentTexts.join('<br/>')
      //             return { type: 'text', name: 'MyText', content: content, components: [] }
      //          }
      //       },
      //    }),
      //    view: originalText.view,
      // })
      //      editor.on('storage:start', startLoading);
      // editor.on('storage:end', endLoading);
      // editor.on("storage:load", function (e) {
      //   console.log("Loaded ", e);
      // });
      // editor.on("storage:store", function (e) {
      //   console.log("Stored ", e);
      // });
      // editor.store((res) => console.log("Store callback", res));
      this.activeLoading = false;
      this.$vs.loading.close();
        const { pm } = this;
   this.setPages(pm.getAll());
   editor.on('page', () => {
     this.pages = [...pm.getAll()];
   });
    },
    setPages(pages) {
      this.pages = [...pages];
    },
    isSelected(page) {
      return this.pm.getSelected().id == page.id;
    },
    selectPage(pageId) {
      return this.pm.select(pageId);
    },
    removePage(pageId) {
      return this.pm.remove(pageId);
    },
    addPage() {
      const { pm } = this;
      // console.log(pm.getSelected())
      const len = pm.getAll().length;
      pm.add({
        name: `Page ${len + 1}`,
        component: `<div>Page ${len + 1}</div>`,
      });
    },
    SaveDraft() {
      const content = this.editor.getHtml();
      const page = this.$route.params.page;
      if (page) {
        this.loader();
        this.$apollo
          .mutate({
            mutation: SAVE_WEB_DRAFT,
            variables: {
              page: page,
              html: content,
            },
          })
          .then((response) => {
            console.log(response);
            if (response) {
              this.activeLoading = false;
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Page Draft",
                text: "Saved successfully!",
                color: "success",
                position: "top-right",
              });
              this.getDrafts();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      //   const orignal_name = this.$route.params.page
      //   const name = Math.random().toString().slice(2)
      // //   this.openLoadingInDiv()
      //   S3Client
      //     .uploadFile(file, name)
      //     .then(response => {
      //         console.log(response)
      //     //   this.$vs.loading.close('#div-with > .con-vs-loading')
      //       this.SaveFile(response, orignal_name)
      //     })
      //     .catch(err => console.error(err))
    },
    ShowPreview() {
      const page = this.$route.params.page;
      if (page) {
        window.open("https://dev3.barqsol.com/basic/" + page, "_blank");
      } else {
        window.open("https://dev3.barqsol.com/basic/preview.html", "_blank");
      }
    },
    Save() {
      if (this.$route.params.page) {
        this.loader();
        // var iframe = document.getElementsByTagName('iframe')[0];
        // var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
        // var frameBody = innerDoc.querySelector('html').innerHTML;
        this.$apollo
          .mutate({
            mutation: SAVE_WEB_TEMP,
            variables: {
              html: this.editor.getHtml(),
              css: this.editor.getCss(),
              page: this.$route.params.page,
            },
          })
          .then((response) => {
            if (response) {
              this.activeLoading = false;
              this.$vs.loading.close();
              this.$vs.notify({
                title: "Page",
                text: "Saved successfully!",
                color: "success",
                position: "top-right",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });

        // localStorage.setItem('getHtml',this.editor.getHtml())
        // localStorage.setItem('getCss',this.editor.getCss());
        // console.log(this.editor.getHtml())
        //  console.log(this.editor.getCss())
      } else {
        this.$vs.notify({
          title: "Page",
          text: "Page Failed to Save!",
          color: "danger",
          position: "top-right",
        });
      }
    },
    showManue() {
      const type = this.layoutType;
      if (type === "vertical") {
        this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "hidden");
      } else {
        this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "vertical");
      }
    },
    hideManue() {
      this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "hidden");
    },
    shwManue() {
      this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "vertical");
    },
    loader() {
      this.activeLoading = true;
      this.$vs.loading({
        type: "sound",
      });
    },
    toggleImageSidebar(val = false) {
      this.ViewSidebar = val;
    },
     toggleMenuSidebar(val = false) {
      this.ViewMenuSidebar = val;
    },
    setImg(src) {
      this.img_src.src = src;
      // const editor = this.editor
      // editor.getSelected().set('src',src)
      //   fabric.util.loadImage(src, function (img) {
      //    console.log(img)
      //   const sideImg = new fabric.Image(img)
      //   sideImg.scaleToWidth(170)
      //   sideImg.scaleToHeight(170)
      //   sideImg.left = 20
      //   sideImg.top = 80
      //   canvas.add(sideImg)
      //   canvas.requestRenderAll()
      // }, null, {crossOrigin: 'Anonymous'})
      //  canvas.renderAll()
    },
    setMenu(menu) {
      this.menuData=menu
      console.log(menu)
      // const editor = this.editor
      // editor.getSelected().set('src',src)
      //   fabric.util.loadImage(src, function (img) {
      //    console.log(img)
      //   const sideImg = new fabric.Image(img)
      //   sideImg.scaleToWidth(170)
      //   sideImg.scaleToHeight(170)
      //   sideImg.left = 20
      //   sideImg.top = 80
      //   canvas.add(sideImg)
      //   canvas.requestRenderAll()
      // }, null, {crossOrigin: 'Anonymous'})
      //  canvas.renderAll()
    },
    submitImg() {
      this.img_active = false;
      const editor = this.editor;
      editor
        .getSelected()
        .setAttributes({
          src: this.img_src.src,
          alt: this.img_src.alt,
          title: this.img_src.title,
        });
      this.img_src = {
        src: "",
        alt: "",
        title: "",
      };
    },
    submitLink() {
      const editor = this.editor;
      const selected = editor.getSelected();
      if (selected && selected.is("link")) {
        if (this.link_src.new) {
          selected.setAttributes({
            href: this.link_src.src,
            title: this.link_src.title,
            target: "_blank",
          });
        } else {
          selected.setAttributes({
            href: this.link_src.src,
            title: this.link_src.title,
          });
        }
      } else {
        console.log(this.linkData);
        console.log(this.linkData.range[0]);
        var range = this.linkData.editor.createRange();
        range.moveToBookmark(this.linkData.range[0]);
        range.select();
         console.log(range)
        var link = "Sdsdsd";
        var data = '<a href="' + link + '" target="_blank">' + link + "</a>";
        this.linkData.editor.editable().insertHtmlIntoRange(data, range, "html");
      
        // var link ="dddddd"
        // this.ckeditor.insertHtml("<a href=\""+link+"\" target=\"_blank\">" + this.linkData.range + "</a>");

        // var sele = this.linkData.editor.getSelection().selectBookmarks( this.linkData.range ).getNative();
        // console.log(this.linkData.editor.getSelection().selectBookmarks( this.linkData.range ).getSelectedText().toString())
        // console.log(sele)

        // var attributes = Array();
        //   attributes["href"] = this.link_src.src;
        //   attributes["title"] = this.link_src.title;
        //   if(this.link_src.new){
        //     attributes["target"] ="_blank";
        //   }
        //  var style = new CKEDITOR.style( { element : 'a', attributes : attributes } );
        //  style.type = CKEDITOR.STYLE_INLINE;
        //  style.applyToRange(range,this.linkData.editor)

        // var style = new CKEDITOR.style( { element : 'a', attributes : attributes } );
        // style.type = CKEDITOR.STYLE_INLINE;
        // // this.linkData.editor.focus()
        // style.apply(this.linkData);

        // const newlink = document.createElement('a');
        // newlink.setAttribute('title', this.link_src.title );
        // newlink.setAttribute('href', this.link_src.src);
        // if(this.link_src.new){
        //   newlink.setAttribute('target', "_blank");
        // }
        // newlink.innerHTML=this.linkData.text
        // console.log(newlink)
        // const full_text = selected.getEl().innerHTML;
        // console.log(full_text);
        // const start_text = full_text.substring(0,this.linkData.start)
        // const end_text = full_text.substring(this.linkData.end,full_text.length)
        // selected.getEl().innerHTML = ""
        // selected.getEl().insertAdjacentHTML('afterbegin', start_text);
        // selected.getEl().append(newlink)
        // // selected.getEl().insertAdjacentHTML('beforeend', newlink);
        // selected.getEl().insertAdjacentHTML('beforeend', end_text);
        // selected.getEl().append(start_text)
        // selected.getEl().append(newlink)
        // selected.getEl().append(end_text)
      }
      this.link_active = false;
    },
    removeLink() {
      var newEl = document.createElement("span");
      newEl.innerHTML = this.editor.getSelected().getEl().innerHTML;

      var tmp = document.createElement("div");
      tmp.appendChild(newEl);
      console.log(tmp.innerHTML); // <p>Test</p>
      console.log(tmp.outerHTML);
      console.log(this.editor.getSelected().getEl().classList);
      this.editor
        .getSelected()
        .getEl()
        .classList.forEach((classname) => {
          console.log(classname);
          // newEl.classList.add(classname);
        });
      console.log(newEl);
      var el = this.editor.getSelected().getEl().innerHTML
        // "<span>" + this.editor.getSelected().getEl().innerHTML + "</span>";
      //  console.log(this.editor.getSelected().getEl())
      const component = this.editor.getSelected();
      const coll = component.collection;
      const at = coll.indexOf(component);
      coll.remove(component);
      return coll.add(el, { at });
    },
    activeLink() {
      const selected = this.editor.getSelected();
      if (selected && selected.is("link")) {
        //  console.log(selected)
        this.link_active = false;
        this.link_src.src = selected.get("attributes").href;
        this.link_src.title = selected.get("attributes").title;
        //  this.link_active=true
      }
      this.link_active = true;
    },
    loadDraft(page) {
      this.draft_active = false;
      page = this.s3Url + "/" + page;
      this.$apollo
        .mutate({
          mutation: GET_DRAFT_CONTENT,
          variables: {
            page: page,
          },
        })
        .then((response) => {
          this.restHtml = response.data.getDraftContent.template;
          // this.editor.setComponents(this.restHtml);
          // this.editor.refresh();
          //   document.getElementById("editor-canvas").remove();
          //   document.querySelector('.panel__top').remove();
          //  var doc = new DOMParser().parseFromString(`<div class="panel__top"><div class="panel__basic-actions"></div><div class="panel__devices"></div><div class="panel__switcher"></div></div>`, "text/xml");
          //   document.getElementById("main_page").append(doc.documentElement)
          //   var doc = new DOMParser().parseFromString(`<div class="editor-canvas" id="editor-canvas"><div id="gjs"></div></div>`, "text/xml");
          //   document.getElementById("main_page").append(doc.documentElement)
          //     this.grapesRender()
          this.editor.setComponents(this.restHtml);
          // const updateComp = (component) => {
          //   console.log(component.is("dltable"));
          //   if (component.is("dltable")) {
          //          component.set({toolbar:[{ attributes: {class: 'fa fa-trash'}, command: 'tlb-delete'}],selectable: true,editable:true,hoverable:false,removable:true,copyable: false,draggable:false,dropable:false,moveable:false,badgable:false});
          //   }
          //   else{
          //         component.set({toolbar:[],selectable: true,editable:true,hoverable:false,removable:false,copyable: false,draggable:false,dropable:false,moveable:false});

          //   }
          //   component.get('components').each(c => updateComp(c))
          // }
          // this.editor.getComponents().each(c => updateComp(c))
         
        });
    },
    getDrafts() {
      this.$apollo
        .mutate({
          mutation: GET_ALL_DRAFT,
          variables: {
            page: this.$route.params.page,
          },
        })
        .then((response) => {
          this.currentDrafts = response.data.allDrafts;
          this.activeLoading = false;
              this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.activeLoading = false;
              this.$vs.loading.close();
        });
    },
  getMainMenu() {
      this.draft_active = false;
      const page = this.s3Url + "/WebMenu/menu"
      this.$apollo
        .mutate({
          mutation: GET_MAIN_MENU,
          variables: {
            page: page,
          },
        })
         .then((response) => {
          // console.log(response.data.getMainMenu.template)
          this.menuRaw=response.data.getMainMenu.template
           this.activeLoading = false;
              this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
           this.activeLoading = false;
              this.$vs.loading.close();
        });
  },
      createMenu(){
        let doc = new DOMParser().parseFromString(this.htmlstring, 'text/html');
        // console.log(doc)
           var parent_div= doc.getElementById('navbarResponsive');
            var ul = doc.createElement("UL");
            ul.classList.add("navigation", "clearfix","navbar-nav");
            var ul2 = doc.createElement("UL");
            ul2.classList.add("navigation", "clearfix","navbar-nav","ml-auto");
            // console.log(ul)
            this.menuData.forEach(function(element,index){
                if(element.type==='page'){
                    var li = doc.createElement("LI");
                    // console.log(li)
                    li.classList.add("nav-item")
                    var nav_link= doc.createElement("a");
                    nav_link.classList.add("nav-link")
                    nav_link.href = element.link; 
                    var link_text = document.createTextNode(element.title);
                    nav_link.appendChild(link_text); 
                    // console.log(nav_link)
                    li.appendChild(nav_link); 
                    if(index < 4){
                     ul.appendChild(li);
                    }
                    else{
                      ul2.appendChild(li);
                    }
                }
            else{
            var li = doc.createElement("LI");
            // console.log(li)
            li.classList.add("nav-item","dropdown")
            var nav_link= doc.createElement("a");
             nav_link.classList.add("nav-link","dropdown-toggle")
             nav_link.href = "#"
             nav_link.setAttribute("data-toggle", "dropdown");
             nav_link.setAttribute("aria-haspopup", "true");
             nav_link.setAttribute("aria-expanded", "false");
             var link_text = document.createTextNode(element.title);
             nav_link.appendChild(link_text); 
             li.appendChild(nav_link);
             var dropdown_div = doc.createElement("div");
             dropdown_div.classList.add("dropdown-menu")
             element.menu.forEach(menu => {
                var drop_link= doc.createElement("a");
                drop_link.classList.add("dropdown-item")
                drop_link.href = menu.link
                var drop_text = document.createTextNode(menu.title);
                drop_link.appendChild(drop_text); 
                dropdown_div.appendChild(drop_link);
             });
                li.appendChild(dropdown_div);
                 if(index < 4){
                     ul.appendChild(li);
                    }
                    else{
                      ul2.appendChild(li);
                    }
                // console.log(dropdown_div)   
                }
            //  console.log(ul)
            });
            //   console.log(ul)   
            //   console.log(ul2)   
         parent_div.appendChild(ul);   
         parent_div.appendChild(ul2);   
        let div = doc.body.firstChild;
       
        div = div.outerHTML
        console.log(div)
        this.menuRaw=div

        // this.SaveMenu(div)
    },
    setPage(page){
    if (page) {
      this.loader();
      this.$apollo
        .mutate({
          mutation: GET_PAGE_CONTENT,
          variables: {
            page: page,
          },
        })
        .then((response) => {
          console.log(response.data.getPageContent.template)
          this.renderPage(response.data.getPageContent.template);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.activeLoading = false;
      this.$vs.loading.close();
     }
    },
    renderPage(content){
      // this.editor.DomComponents.getWrapper().set('content', ''); 
      // this.editor.DomComponents.clear();
      this.editor.setComponents(content);
      this.addType()
      this.activeLoading = false;
      this.$vs.loading.close();
    },
    addType(){
       const updateAll = (model) => {
            model.onAll((innerComponent) => {
              // console.log(innerComponent.get("type"));
              if (innerComponent.is("dltable")) {
                //  console.log(innerComponent.getEl())
                innerComponent.set({
                  toolbar: [
                    {
                      attributes: { class: "fa fa-trash" },
                      command: "tlb-delete",
                    },
                    {
                      attributes: { class: "fa fa-arrow-up" },
                      command: "move-up",
                    },
                    {
                      attributes: { class: "fa fa-arrow-down" },
                      command: "move-down",
                    },
                  ],
                  selectable: true,
                  editable: true,
                  hoverable: false,
                  removable: true,
                  copyable: false,
                  draggable: false,
                  dropable: false,
                  moveable: false,
                  badgable: false,
                });
              } else {
                innerComponent.set({
                  toolbar: [],
                  selectable: true,
                  editable: true,
                  hoverable: false,
                  removable: false,
                  copyable: false,
                  draggable: false,
                  dropable: false,
                  moveable: false,
                });
                 innerComponent.set({toolbar:[{ attributes: {class: 'fa fa-trash'}, command: 'tlb-delete'} ,{ attributes: {class: 'fa fa-arrow-up'}, command: 'move-up' }, { attributes: {class: 'fa fa-arrow-down'}, command: 'move-down' },],selectable: true,editable:true,hoverable:false,removable:true,copyable: false,draggable:false,dropable:false,moveable:false,badgable:false});
              }
            });
            // model.set({toolbar:[],selectable: false,editable:true,hoverable:false,removable:false,copyable: false,draggable:false,dropable:false,moveable:false});
            model.get("components").each((model) => updateAll(model));
          };
           updateAll(this.editor.DomComponents.getWrapper());
    }
     },
  created() {
    this.getMainMenu();
    // this.loader()
    this.getDrafts();
  }
}
</script>

<style >
#gjs {
  border: 3px solid #444;
}
.gjs-block {
  width: auto;
  height: auto;
  min-height: auto;
}
/* Reset some default styling */
.gjs-cv-canvas {
  top: 0;
  width: 100%;
  height: 100%;
}
.panel__top {
  padding: 0;
  width: 100%;
  display: flex;
  position: initial;
  justify-content: center;
  justify-content: space-between;
}
.panel__basic-actions {
  position: initial;
}
.panel__side-actions {
  position: initial;
  display: inline-flex
}
.editor-row {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: nowrap;
  height: 300px;
  height: 100%;
  overflow-y: auto;
}

.editor-canvas {
  flex-grow: 1;
}

.panel__right {
  flex-basis: 230px;
  position: relative;
  overflow-y: auto;
  height: 100%;
}
.panel__switcher {
  position: initial;
}
.panel__devices {
  position: initial;
}
#gjs {
  border: none;
}
/* Theming */

/* Primary color for the background */
.gjs-one-bg {
  background-color: #2c2c2c;
}

/* Secondary color for the text color */
.gjs-two-color {
  color: white;
}

/* Tertiary color for the background */
.gjs-three-bg {
  background-color: #2c2c2c;
  color: white;
}

/* Quaternary color for the text color */
.gjs-four-color,
.gjs-four-color-h:hover {
  color: white;
}
.gjs-cv-canvas {
  /* remove the right gap */
  width: 100%;

  /* remove the top gap */
  height: 100%;
  top: 0;
}
/* Let's highlight canvas boundaries */
#gjs {
  border: 3px solid #444;
}
.gjs-block {
  width: 100%;
}
#blocks {
  width: 100%;
  height: auto;
}
.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.footer-sidebar button {
  border: 0px solid rgba(0, 0, 0, 0) !important;
  border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 0px !important;
}
.vs-sidebar {
  z-index: 99999 !important;
}

.vs-sidebar--background {
  width: 0% !important;
}

.app-wrap {
  height: 100%;
  width: 100%;
  display: flex;
}
.editor-wrap {
  width: 100%;
  height: 100%;
}
.pages-wrp,
.pages {
  display: flex;
  flex-direction: column;
}
.editor {
  width: 100%;
  height: 100%;
}
.pages-manager,
.pages {
  display: flex;
  flex-direction: column;
}
.pages-manager {
  background: #333;
  padding: 5px;
}
.add-page {
  background: #444444;
  color: white;
  padding: 5px;
  border-radius: 2px;
  cursor: pointer;
  white-space: nowrap;
  margin-bottom: 10px;
}
.page {
  background-color: #444;
  color: white;
  padding: 5px;
  margin-bottom: 5px;
  border-radius: 2px;
  cursor: pointer;
}
.page-close {
  opacity: 0.5;
  /* float: right; */
  background-color: #2c2c2c;
  height: 20px;
  display: inline-block;
  width: 17px;
  text-align: center;
  border-radius: 3px;
}
#img_sidebar > .vs-sidebar {
  max-width: 400px;
}
#draft_sidebar > .vs-sidebar {
  max-width: 400px;
}
#link_sidebar > .vs-sidebar {
  max-width: 400px;
}
#menu_sidebar > .vs-sidebar {
  max-width: 400px;
}
</style>


